import {classNames, CloseButton, IconNames, layout, MaterialIcon, theme} from "@variocube/cube-ui";
import * as React from "react";
import {stylesheet} from "typestyle";
import {useLocalization} from "../../i18n";

export interface BookingViewHeaderProps {
    title: string;
    onBack?: () => any;
    onClose: () => any;
}

export function BookingViewHeader({title, onBack, onClose}: BookingViewHeaderProps) {
    const {t} = useLocalization();
    return (
        <div className={classNames(layout.horizontal)}>
            {onBack && (
                <div className={classNames(styles.backButton, theme.lessContrast)}>
                    <MaterialIcon icon={IconNames.arrow_back}/>
                    {t("Back")}
                </div>
            )}
            <div className={classNames(layout.fill, layout.horizontal, theme.lessContrast)}>
                <div className={classNames(styles.title)}>
                    {title}
                </div>
            </div>
            <CloseButton label={t("Done")} onClick={onClose}/>
        </div>
    )
}

const styles = stylesheet({
    title: {
        textTransform: "uppercase",
        padding: "0.75rem 1.5rem",
        fontSize: "1.25em",
        flex: "1 1 auto",
    },
    backButton: {
        fontSize: "1.25em",
        textTransform: "uppercase",
        display: "flex",
        alignItems: "center",
        marginRight: "0.25rem",
        padding: "0.25rem 1.5rem",
    }
})